import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

export const LDRLoan = {
  GetAutoImage: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'loan/vehicleimage'
  } as DataLoadURL,
  GetLoanDetail: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'loan/application'
  } as DataLoadURL,
  GetOLAPostAppTaskDetail: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'postapplication/ola/tasks'
  } as DataLoadURL,
  GetLoanOLADetail: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'loan/application'
  } as DataLoadURL,
  GetOLAOverviewBanner: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'postapplication/ola/banner'
  } as DataLoadURL,
  GetLoanList: {
    hostName: 'ldr-api',
    method: 'GET',
    url: 'loans?lenderCode={lenderCode}&last4OfSsn={last4OfSsn}&emailAddress={emailAddress}&dateOfBirth={dateOfBirth}&lastName={lastName}'
  } as DataLoadURL,
  GetAllLoans: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'loan/appsummaries'
  } as DataLoadURL,
  GetLoanCollection: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'loan'
  } as DataLoadURL,
  SelectLoan: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/dynamic/bundle/select'
  } as DataLoadURL,
  SelectOAOLoan: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/dynamic/bundle/selectoaobundle'
  } as DataLoadURL,
  SelectOLALoan: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/ola/dynamic/bundle/select'
  } as DataLoadURL,
  ApplyForMembership: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/ola/dynamic/bundle/applyForMembership'
  } as DataLoadURL,
  DisburseLoanProceeds: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/ola/dynamic/bundle/disburseLoanProceeds'
  } as DataLoadURL,
  DownLoadESignDocument: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'member/oao/integration/DownloadeSignDocument/{{loanNumber}}/{envelopId}'
  } as DataLoadURL,
  CreateOLALoan: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/ola/dynamic/createLoan?olaAuthorization={olaAuthorization}'
  } as DataLoadURL
};
